import { createFeatureSelector, createSelector } from '@ngrx/store';
import { auditLogSelectors } from '../shared-audit.adapters';
import { State } from '..';
import * as fromSimulatedFlight from './simulated-flight.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');

// feature slice - simulated flight
const getSimulatedFlightSubState = createSelector(
  getSharedAuditState,
  state => state.simulatedFlight
);

// simulated flight slices
const getSimulatedFlightSkeletonState = createSelector(
  getSimulatedFlightSubState,
  state => state.simulatedFlightSkeletons
);
const getSimulatedFlightAuditState = createSelector(
  getSimulatedFlightSubState,
  state => state.simulatedFlightAudit
);

// skeletons
export const getLogbookSelectedPilot = createSelector(
  getSimulatedFlightSkeletonState,
  state => state.logbookSelectedPilot
);
export const getSimulatedFlightSkeletonLoading = createSelector(
  getSimulatedFlightSkeletonState,
  state => state.loading
);
export const getSimulatedFlightSkeletonLoaded = createSelector(
  getSimulatedFlightSkeletonState,
  state => state.loaded
);
export const getSimulatedFlightSkeletons = createSelector(
  getSimulatedFlightSkeletonState,
  fromSimulatedFlight.simulatedFlightSkeletonsSelectors.selectAll
);

// simulated flight audit
export const getSimulatedFlightAuditLoading = createSelector(
  getSimulatedFlightAuditState,
  state => state.loading
);
export const getSimulatedFlightAuditLoaded = createSelector(
  getSimulatedFlightAuditState,
  state => state.loaded
);
export const getSimulatedFlightAudit = createSelector(
  getSimulatedFlightAuditState,
  auditLogSelectors.selectAll
);
